import React, { Fragment, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import content from './content'
const MainPage = () => {
  const param = useParams()
  console.log('🚀 ~ MainPage ~ param:', param)
  const [lang, setLang] = useState(param?.lang || 'eu')
  useEffect(() => {}, [])
  useEffect(() => {
    setLang(param.lang)
    document.title = content[param.lang]?.title || content['eu'].title
  }, [param.lang])
  return (
    <Fragment>
      {(content[lang]?.content || content['eu'].content).map((item, idx) => {
        return <div dangerouslySetInnerHTML={{ __html: item }} key={idx} />
      })}
    </Fragment>
  )
}

export default MainPage
